import React, { Component } from 'react';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from '../styles';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class Variable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  
  render() {
    const { classes, t } = this.props;
    return (
      <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
      >
        <Typography className={classes.textGrey} variant="h4">{t('template-management.variables-template.title')}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
        style={{padding:"4px"}}
        
      >
        <Typography className={[classes.textGrey, classes.size12]} variant='body2'>{t('template-management.variables-template.text1')}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
        style={{padding:"0px"}}
      >
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item1')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item2')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item3')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item4')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item5')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item6')}</Typography>
        <Typography className={classes.textGrey} variant='body2'>{t('template-management.variables-template.list.item7')}</Typography>
        
      </Grid>
    </Grid>
             
    )
  }
}

export default compose(withStyles(styles), withTranslation())(Variable);
